<template>
	<div class="ModuleBox">
		<div class="ModuleBoxBackground"></div>
		<div class="ModuleBoxBody">
			<div class="ModuleBoxBodyBody">
				<div class="ModuleBoxBodyBodyLogo">
					<el-image :src="LogoUrl" fit="scale-down" />
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	@import "./index.scss";
</style>
<script>
  import index from "./index-Js";
  export default index;
</script>
